import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  ButtonGroup,
  Grow,
  MenuItem,
  MenuList,
  Paper,
  Popper,
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import { find } from 'lodash-es';

SelectButton.propTypes = {
  sx: PropTypes.object,
  onChange: PropTypes.func,
  value: PropTypes.any,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.any.isRequired,
      label: PropTypes.string.isRequired,
    }),
  ).isRequired,
};

export function SelectButton(props) {
  const { options, sx, onChange, value } = props;
  const [open, setOpen] = useState(false);
  const anchorRef = useRef(null);

  function handleToggle() {
    setOpen((prevOpen) => !prevOpen);
  }

  function handleOptionClick(option) {
    handleToggle();
    if (onChange && option.value !== value) onChange(option.value);
  }

  function handleClose(event) {
    if (anchorRef.current && anchorRef.current.contains(event.target)) return;
    setOpen(false);
  }

  const displayValue = find(options, { value })?.label || <AddIcon />;

  return (
    <>
      <ButtonGroup fullWidth sx={sx} variant="text" ref={anchorRef}>
        <Button color="inherit" onClick={handleToggle}>
          {displayValue}
        </Button>
      </ButtonGroup>

      <Popper
        sx={{ zIndex: 3 }}
        open={open}
        anchorEl={anchorRef.current}
        transition
        modifiers={[{ name: 'offset', options: { offset: [0, -36] } }]}
      >
        {({ TransitionProps }) => (
          <Grow {...TransitionProps} style={{ transformOrigin: 'top right' }}>
            <Paper>
              <ClickAwayListener onClickAway={handleClose}>
                <MenuList>
                  {options.map((option, index) => (
                    <MenuItem
                      key={index}
                      selected={option.value === value}
                      onClick={handleOptionClick.bind(null, option)}
                    >
                      {option.label}
                    </MenuItem>
                  ))}
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    </>
  );
}
